import React from 'react';
import { DataTable } from 'components/uiParts/DataGrid/DataTable';
import { Breadcrumb } from 'components/uiParts/Breadcrumb';
// 定数ファイル
import { CUSTOMER_CATEGORY_COLUMNS } from 'utils/constantsTable';

export const CustomerCategory2ListPage = () => {
  const breadcrumbList = [
    { name: 'ダッシュボード', href: '/' },
    { name: '得意先区分2一覧', href: '/customerCategory2/list' },
  ];
  return (
    <>
      <Breadcrumb breadcrumbList={breadcrumbList} />
      <DataTable
        title='得意先区分2一覧'
        columns={CUSTOMER_CATEGORY_COLUMNS}
        table='CustomerCategory2'
        api='CustomerCategory2'
        isCreateBtn
        isDetailBtn
        isDeleteBtn
        createUrl='/customerCategory2/create'
        detailUrl='/customerCategory2/detail'
        defaultFilterColumn='name'
        defaultFilterOperator='contains'
      />
    </>
  );
};
